(function () {
	let swiperCollectionGrid;
	const collectionGridSwipeEnabled = document.querySelector(
		".swiper--collection-grid"
	);

	const initSlider = () => {
		collectionGridSwipeEnabled.classList.add("collection-grid-swiper-wrapper");
		const slides = document.querySelectorAll(".collection-grid__box");

		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});

		swiperCollectionGrid = new Swiper(".swiper--collection-grid", {
			loop: false,
			slidesPerView: 1.15,
			spaceBetween: 16,
			navigation: {
				nextEl: ".collection-grid-button-next",
				prevEl: ".collection-grid-button-prev",
			},
		});
	};

	const destroySlider = () => {
		collectionGridSwipeEnabled.classList.remove(
			"collection-grid-swiper-wrapper"
		);
		const slides = document.querySelectorAll(".collection-grid__box");

		swiperCollectionGrid.destroy(true, true);
		swiperCollectionGrid = undefined;

		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initCollectionGrid = () => {
		const collectionGridSection = document.querySelector(".collection-grid");

		if (!collectionGridSection || !collectionGridSwipeEnabled) return;

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 576 && collectionGridSwipeEnabled) {
				if (!swiperCollectionGrid) initSlider();
			} else if (swiperCollectionGrid) {
				destroySlider();
			}
		});

		sectionResizeObserver.observe(collectionGridSection);
	};

	initCollectionGrid();
	document.addEventListener("shopify:section:load", function () {
		if (swiperCollectionGrid) {
			destroySlider();
		}
		initCollectionGrid();
	});
})();
